export default function Story() {
  return (
    <section id="story" className="bg-uken-dark py-20 md:py-28 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="mb-14">
          <span className="inline-block bg-white/10 text-white/70 text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-4">
            / STORY
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-rounded font-black text-white leading-tight mb-3">
            畑の手と、窯の手。
          </h2>
          <p className="text-white/75 font-rounded text-base">
            たんかん農家が、なぜかピザ屋をはじめた話。
          </p>
        </div>

        {/* Main content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center mb-16">
          <div>
            <p className="text-white/95 font-rounded text-base md:text-lg leading-[1.9] mb-6">
              もともとは、宇検村でたんかんを育てる農家。<br />
              「なんで農家がピザ？」って、よく聞かれます。
            </p>
            <p className="text-white/95 font-rounded text-base md:text-lg leading-[1.9] mb-6">
              たんかんって、実るまでに何年もかかるんです。<br />
              手をかけて、待って、やっと届けられる。<br />
              でも関わる人の「おいしい！」を聞けるのは、ほんの一瞬。<br />
              もっと目の前で「おいしい」が見たい。
            </p>
            <p className="text-white/95 font-rounded text-base md:text-lg leading-[1.9] mb-6">
              そう思ったとき、出会ったのが窯焼きピザでした。<br />
              生地をこねて、400℃の窯に入れて、たった5分。<br />
              焼きたてを渡した瞬間の「おいしい！」が、すぐそこにある。
            </p>
            <p className="text-white/95 font-rounded text-base md:text-lg leading-[1.9] mb-8">
              畑で何年もかけて届ける「おいしい」と、<br />
              窯の前で5分で届ける「おいしい」。<br />
              どっちも、中村さんにとっては同じ気持ちなんです。
            </p>
            <blockquote className="border-l-4 border-tankan pl-5">
              <p className="text-white font-rounded font-bold text-lg italic leading-relaxed">
                「ふうばては、そんな農家の「届けたい」から生まれたお店です。」
              </p>
              <cite className="text-white/60 text-sm font-rounded mt-2 block not-italic">
                
              </cite>
            </blockquote>
          </div>

          <div className="flex flex-col gap-4">
            <div className="w-full h-64 rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/fa962a6ff1430bf5fdd5508b05918f84.webp"
                alt="たんかん畑 - 宇検村"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="w-full h-64 rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/0b6308cab95cd2b4bb0a4fd30093af0e.webp"
                alt="ピザ窯の前に立つオーナーのシルエット"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>
        </div>

        {/* Stats bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { value: 'ふぅばてぇ', label: '宇検村の', note: '手ごね窯焼きピザ専門店' },
            { value: 'たんかん', label: '宇検村の', note: '農家' },
            { value: '手ごね', label: '毎回', note: 'ゼロから生地を' },
            { value: '400℃', label: '窯', note: '一気に焼く' },
          ].map((stat) => (
            <div key={stat.value} className="bg-white/10 rounded-xl p-5 text-center">
              <p className="text-white font-rounded font-black text-xl mb-1">{stat.value}</p>
              <p className="text-white/70 text-xs font-rounded">{stat.label}</p>
              <p className="text-white/85 text-xs font-rounded mt-0.5">{stat.note}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
